import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/index.vue'
import Mine from '../pages/mine/index.vue'
import Choose from '../pages/choose/index.vue'
import List from '../pages/choose/list.vue'
import Profile from '../pages/choose/profile.vue'
import Video from '../pages/video/index.vue'
import Login from '../pages/login/index.vue'
import Register from '../pages/login/register.vue'
import ServiceOnline from '../pages/mine/ServiceOnline.vue'
import ServicePage from '../pages/mine/ServicePage.vue'
import Setting from '../pages/mine/Setting.vue'
import Infomation from '../pages/mine/Infomation.vue'
import IndexInfo from '../pages/mine/IndexInfo.vue'
import Setname from '../pages/mine/Setname.vue'
import Setsex from '../pages/mine/Setsex.vue'
import Recharge from '../pages/mine/Recharge.vue'
import SetPayPassword from '../pages/mine/SetPayPassword.vue'
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'
import Start from '../pages/start/index.vue'
import Membership from '../pages/membership/index.vue'
import Notice from '../pages/mine/Notice.vue'
import PlayVideo from '../pages/video/PlayVideo'
import Setbank from '../pages/mine/Setbank'
import BindCard from '../pages/mine/BindCard'
import Withdraw from '../pages/mine/Withdraw'
import Personalreport from '../pages/mine/Personalreport'
import GameRecord from '../pages/mine/GameRecord'
import WithdrawRecord from '../pages/mine/WithdrawRecord'
import Details from '../pages/mine/details'

Vue.use(VueRouter)

const title = "Star of Harmony · Lovers' Haven"
const routes = [
  { path: '/', redirect: '/Home', component: Home, meta: { title } },
  { path: '/Home', name: 'home', component: Home, meta: { title } },
  { path: '/Choose', name: 'choose', component: Choose, meta: { title } },
  { path: '/List', name: 'list', component: List, meta: { title } },
  { path: '/Profile', name: 'profile', component: Profile, meta: { title } },
  { path: '/Mine', name: 'mine', component: Mine, meta: { title } },
  { path: '/Video', name: 'video', component: Video, meta: { title } },
  { path: '/Login', name: 'login', component: Login, meta: { title } },
  { path: '/Register', name: 'register', component: Register, meta: { title } },
  { path: '/ServiceOnline', name: 'ServiceOnline', component: ServiceOnline, meta: { title } },
  { path: '/ServicePage', name: 'ServicePage', component: ServicePage, meta: { title } },
  { path: '/Setting', name: 'Setting', component: Setting, meta: { title } },
  { path: '/Infomation', name: 'Infomation', component: Infomation, meta: { title } },
  { path: '/IndexInfo', name: 'IndexInfo', component: IndexInfo, meta: { title } },
  { path: '/Setname', name: 'Setname', component: Setname, meta: { title } },
  { path: '/Setsex', name: 'Setsex', component: Setsex, meta: { title } },
  { path: '/Recharge', name: 'Recharge', component: Recharge, meta: { title } },
  { path: '/SetPayPassword', name: 'SetPayPassword', component: SetPayPassword, meta: { title } },
  { path: '/SetLoginPassword', name: 'SetLoginPassword', component: SetLoginPassword, meta: { title } },
  { path: '/Start', name: 'start', component: Start, meta: { title } },
  { path: '/Membership', name: 'membership', component: Membership, meta: { title } },
  { path: '/Notice', name: 'Notice', component: Notice, meta: { title } },
  { path: '/PlayVideo', name: 'PlayVideo', component: PlayVideo, meta: { title } },
  { path: '/Setbank', name: 'Setbank', component: Setbank, meta: { title } },
  { path: '/BindCard', name: 'BindCard', component: BindCard, meta: { title } },
  { path: '/Withdraw', name: 'Withdraw', component: Withdraw, meta: { title } },
  { path: '/Personalreport', name: 'Personalreport', component: Personalreport, meta: { title } },
  { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord, meta: { title } },
  { path: '/GameRecord', name: 'GameRecord', component: GameRecord, meta: { title } },
  { path: '/detail', name: 'Details', component: Details, meta: { title } },
]

const router = new VueRouter({ routes })
router.beforeEach((to, from, next) => {
  document.title = to.matched[0].meta.title
  next()
})

export default router
